import { axiosPost } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import Store from 'redux/Store'
import setMessage from 'shared/redux/actions/setMessage'
import displayGenError from 'shared/utils/displayGenError'

interface sendEmailReportProps {
  selectedUsers: any
  setShowOverlay: Function
  setBulkActionsEnabled: Function
  setIsSendEmailReportsRequestLoading: Function
}

const sendEmailReport = async (props: sendEmailReportProps) => {
  props.setIsSendEmailReportsRequestLoading(true)
  props.setBulkActionsEnabled(false)
  let selectedUserIds: any = []

  props.selectedUsers.forEach((selectedUser) => selectedUserIds.push(selectedUser.id))

  const formData = {
    users: selectedUserIds,
  }

  const response = await axiosPost(
    apiUrls.users + '/' + apiUrls.actionSendEmailReport,
    formData,
    (err: AxiosError) => {
      switch (err.response!.status) {
        case 500:
          Store.dispatch(
            setMessage(err.response!.data?.message ?? 'An error occurred', 'error', 'instant'),
          )
          break
        default:
          displayGenError({ setShowOverlay: () => {} })
      }
      return err.response
    },
  ).then((res) => {
    props.setIsSendEmailReportsRequestLoading(false)
    props.setBulkActionsEnabled(true)
    if (res!.status === 200) {
      const successText =
        selectedUserIds.length > 1 ? 'Emails have been sent.' : 'Email has been sent.'
      Store.dispatch(setMessage(successText, 'success', 'instant'))
    }
  })
}

export default sendEmailReport
